import Vue from "vue";
import Vuex from "vuex";
import * as _ from "lodash";
const axios = require("axios");
import { HTTP, HTTP2 } from "./src/axios/http-common";
import templates from "./src/Inventory/smsTemplates.json";

// import toast from './toast'

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    authstatus: false,
    extension_payment_failure: [],
    makingAJAX: false,
    customers: [],
    waitlist: [],
    new_bookings: [],
    expired_bookings: [],
    load_chat: false,
    notes: [],
    failed_bookings: [],
    models_list: [],
    reminders: [],
    duePayList: [],
    drop_vehicle: [],
    new_customers: [],
    total_vehicles: [],
    booking_by_date: [],
    booking_date: [],
    dropped_vehicle_by_date: [],
    customer_by_number: [],
    vehicle_count: [],
    sucess_source_count: [],
    fail_source_count: [],
    squadData: [],
    sidenav_toggler: false,
    loading_api: false,
    reminder_count: 0,
    messages_count: 0,
    agents: [],
    navigationStatus: false,
    sucess_by_dates: [],
    service_request: [],
    loan_request: [],
    loan_request_count: [],
    shop_lead: [],
    otr_purchase_sucess: [],
    otr_purchase_failed: [],
    loan_against_vehicle: [],
    loan_against_vehicle_count: [],

    two_wheeler_loan: [],
    two_wheeler_loan_count: [],
    customer_data: [],
    customer_activities: [],
    customer_points: [],
    bookingHistory: [],
    booking_by_id: [],
    point_ledger: [],
    customer_waitlist: [],
    coupon_history: [],
    collection_history: [],
    dropped_vehicle_between_date: [],
    pickup_vehicle_between_date: [],
    extend_payment_data: [],
    agentActivity: [],
    searchSEO: [],
    knowlarity_data: [],
    knowlarity_agents: [],
    knowlarity_data_by_phone: [],
    shop_interest: [],
    missed_call_data: [],
    traffic_violation: [],
    token: "" || localStorage.getItem("user-token"),
    paymentFailedCount: "",
    userName: "",
    smsData: "",
    get_template_data: "",
    agent_comment_data: [],
    changeStatusModal: false,
    get_idfc_loan_data: [],
    paymentRetrievalHistory: [],
    paymentRetrievalHistoryById: [],
    retrievalPaymentHistoryHistoryById: [],
    paymentRetrievalOverview: "",
    homepageData: [],
    online: 0,
  },
  mutations: {
    isOnline(state, value) {
      state.isOnline = value;
    },
    GET_HOMEPAGE_DATA(state, value) {
      state.homepageData = value;
    },
    GET_PAYMENT_TICKET_OVERVIEW(state, value) {
      state.paymentRetrievalOverview = value;
    },
    GET_PAYMENT_TICKET(state, value) {
      state.paymentRetrievalHistory = value;
    },
    GET_PAYMENT_TICKET_BY_ID(state, value) {
      state.paymentRetrievalHistoryById = value;
    },
    GET_RETRIEVAL_PAYMENT_BY_ID(state, value) {
      state.retrievalPaymentHistoryHistoryById = value;
    },
    CHANGE_STATUS_MODAL_TOGGLE(state, value) {
      state.changeStatusModal = value;
    },
    AUTH_REQUEST: (state) => {
      state.authstatus = "loading";
    },
    AUTH_SUCCESS: (state, token) => {
      // state.authstatus = 'success'
      state.token = token;
      state.userName = token.userName;
    },
    AUTH_ERROR: (state) => {
      state.authstatus = "error";
    },
    AUTH_LOGOUT: (state) => {
      state.authstatus = "";
      state.token = "";
    },
    LOADING_API(state, value) {
      state.loading_api = value;
    },
    GET_SMS_DATA(state, smsData) {
      state.smsData = smsData;
    },
    AGENT_COMMENT_DATA(state, agent_comment_data) {
      state.agent_comment_data = agent_comment_data;
    },

    GET_TEMPLATE_DATA(state, get_template_data) {
      state.get_template_data = get_template_data;
    },
    GET_IDFC_LOAN_DATA(state, get_idfc_loan_data) {
      state.get_idfc_loan_data = get_idfc_loan_data;
    },
    GET_EXTENSION_PAYMENT_FAILURE(state, extension_payment_failure) {
      state.extension_payment_failure = extension_payment_failure;
    },
    GET_EXTENSION_PAYMENT_FAILURE_COUNT(state, paymentFailedCount) {
      state.paymentFailedCount = paymentFailedCount;
    },
    GET_CX(state, customers) {
      state.customers = customers;
    },
    GET_BOOKING_BY_ID(state, value) {
      state.booking_by_id = value;
    },
    GET_WAITLIST(state, waitlist) {
      state.waitlist = waitlist;
    },
    GET_FAILED_BOOKING(state, failed_booking) {
      state.failed_bookings = failed_booking;
    },
    GET_NEW_BOOKING(state, new_booking) {
      state.new_bookings = new_booking;
    },
    GET_BOOKING_HISTORY(state, bookingHistory) {
      state.bookingHistory = bookingHistory;
    },
    GET_POINT_LEDGER(state, point_ledger) {
      state.point_ledger = point_ledger;
    },
    GET_BOOKING_BY_DATE(state, booking_by_date) {
      state.booking_by_date = booking_by_date;
    },
    GET_BOOKING_DATE(state, booking_date) {
      state.booking_date = booking_date;
    },
    GET_EXPIRED_BOOKING(state, expired_booking) {
      state.expired_bookings = expired_booking;
    },
    GET_NOTES(state, value) {
      state.notes = value;
    },
    GET_MODELS(state, value) {
      state.models_list = value;
    },
    GET_KNOWLARITY_DATA(state, value) {
      state.knowlarity_data = value;
    },
    GET_KNOWLARITY_DATA_BY_PHONE(state, value) {
      state.knowlarity_data_by_phone = value;
    },
    GET_KNOWLARITY_AGENTS(state, value) {
      state.knowlarity_agents = value;
    },
    GET_REMINDER(state, value) {
      state.reminders = value;
    },
    GET_DUE_PAY(state, value) {
      state.duePayList = value;
    },
    GET_REMINDER_COUNT(state, value) {
      state.reminder_count = value;
    },
    GET_MESSAGES_COUNT(state, value) {
      state.messages_count = value;
    },
    GET_DROP_VEHICLE(state, value) {
      state.drop_vehicle = value;
    },
    GET_SERVICE_REQUEST(state, value) {
      state.service_request = value;
    },
    GET_LOAN_REQUEST(state, value) {
      state.loan_request = value;
    },
    GET_SHOP_LEAD(state, value) {
      state.shop_lead = value;
    },
    GET_SHOP_INTERESTED(state, value) {
      state.shop_interest = value;
    },
    GET_LOAN_AGAINST_VEHICLE(state, value) {
      state.loan_against_vehicle = value;
    },
    LOAN_AGAINST_VEHICLE_COUNT(state, value) {
      state.loan_against_vehicle_count = value;
    },
    LOAN_REQUEST_COUNT(state, value) {
      state.loan_request_count = value;
    },
    TWO_WHEELER_LOAN(state, value) {
      state.two_wheeler_loan = value;
    },
    TWO_WHEELER_LOAN_COUNT(state, value) {
      state.two_wheeler_loan_count = value;
    },
    GET_OTR_PURCHASE_SUCESS(state, value) {
      state.otr_purchase_sucess = value;
    },
    GET_OTR_PURCHASE_FAILED(state, value) {
      state.otr_purchase_failed = value;
    },
    GET_NEW_CUSTOMERS(state, value) {
      state.new_customers = value;
    },
    GET_TOTAL_VEHICLES(state, value) {
      state.total_vehicles = value;
    },
    GET_SUCESS_SOURCE_COUNT(state, value) {
      state.sucess_source_count = value;
    },
    GET_FAIL_SOURCE_COUNT(state, value) {
      state.fail_source_count = value;
    },
    GET_SUCESS_BY_DATES(state, value) {
      state.sucess_by_dates = value;
    },
    GET_DROP_VEHICLE_BY_DATE(state, value) {
      state.dropped_vehicle_by_date = value;
    },
    GET_DROP_VEHICLE_BETWEEN_DATE(state, value) {
      state.dropped_vehicle_between_date = value;
    },
    GET_EXTEND_PAYMENT_DATA(state, value) {
      state.extend_payment_data = value;
    },
    GET_PICKUP_VEHICLE_BETWEEN_DATE(state, value) {
      state.pickup_vehicle_between_date = value;
    },
    VEHICLE_COUNT(state, value) {
      state.vehicle_count = value;
    },
    GET_CX_BY_NUM(state, customer_by_number) {
      state.customer_by_number = customer_by_number;
    },
    searchSEO(state, searchSEO) {
      state.searchSEO = searchSEO;
    },
    GET_CX_ACTIVITY(state, customer_activities) {
      state.customer_activities = customer_activities;
    },
    GET_CX_WAITLIST(state, customer_waitlist) {
      state.customer_waitlist = customer_waitlist;
    },
    GET_CX_COUPON_HISTORY(state, coupon_history) {
      state.coupon_history = coupon_history;
    },
    GET_CX_COLLECTION_HISTORY(state, collection_history) {
      state.collection_history = collection_history;
    },
    GET_AGENT_ACTIVITY(state, agentActivity) {
      state.agentActivity = agentActivity;
    },
    GET_CX_POINTS(state, customer_points) {
      state.customer_points = customer_points;
    },
    GET_CX_DATA(state, customer_data) {
      state.customer_data = customer_data;
    },
    GET_AGENT(state, agents) {
      state.agents = agents;
    },
    SQUAD_DATA(state, data) {
      state.squadData = data;
    },
    TRAFFIC_VIOLATION(state, data) {
      state.traffic_violation = data;
    },
    GET_MISSED_CALL_DATA(state, missed_call_data) {
      state.missed_call_data = missed_call_data;
    },
  },
  actions: {
    callKnowlarity: ({ commit }, payload) => {
      console.log(commit);
      var number = payload.number;
      if (number.substring(0, 3) != "+91") {
        number = "+91" + number;
      }
      return new Promise((resolve, reject) => {
        HTTP2.get("get/agent?id=" + localStorage.getItem("agent_id")).then(
          (x) => {
            var agentNumber = x.data.mobile;
            if (agentNumber.substring(0, 3) != "+91") {
              agentNumber = "+91" + agentNumber;
            }
            axios
              .post(
                "https://kpi.knowlarity.com/Basic/v1/account/call/makecall",
                {
                  k_number: "+919148518401",
                  agent_number: agentNumber, //x.data.mobile
                  customer_number: number,
                  caller_id: "+91xxxxxxxxxx",
                },
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: "e3dce252-7fb2-4a9f-9df7-24c1260bc9d3",
                    "x-api-key": "WLt7gg1bF02glZihlGwOB4V1bAifEQgd7Rnzaxil",
                  },
                }
              )
              .then((x) => {
                resolve(x);
              })
              .catch((err) => {
                reject(err);
              });
          }
        );
      });
    },
    switchUser: ({ commit }, payload) => {
      return new Promise((resolve, reject) => {
        try {
          let userId = Number(localStorage.getItem("agent_id"));
          HTTP2.post("agent/switch", {
            online: payload.online,
            id: userId,
            notify: payload.notify,
          });
          commit("isOnline", payload.online);
          resolve(userId);
        } catch (error) {
          reject(error);
        }
      });
    },
    addActivity: ({ commit }, payload) => {
      console.log(commit);
      return new Promise((resolve, reject) => {
        try {
          HTTP2.post("create/activity", payload)
            .then(resolve({ msg: "Activity Created" }))
            .catch((error) => {
              reject(error);
            });
        } catch (error) {
          reject(error);
        } finally {
          resolve({ msg: "Activity Created" });
        }
      });
    },
    AUTH_REQUEST: ({ commit }, user) => {
      return new Promise((resolve, reject) => {
        // The Promise used for router redirect in login
        commit("AUTH_REQUEST");
        HTTP2.post("/profile/agent/login", user)
          .then((resp) => {
            const token = resp.data.userData.token;
            localStorage.setItem("agentToken", resp.data.userData.token);
            localStorage.setItem("userData", token); // store the token in localstorage
            commit("AUTH_SUCCESS", token); // you have your token, now log in your user :)
            HTTP2.defaults.headers["Authorization"] = "Bearer " + token;
            resolve(resp.data.userData);
          })
          .catch((err) => {
            commit("AUTH_ERROR", err);
            localStorage.removeItem("user-token"); // if the request fails, remove any possible user token if possible
            reject(err);
          });
      });
    },
    AUTH_LOGOUT: ({ commit }) => {
      return new Promise((resolve) => {
        commit("AUTH_LOGOUT");
        localStorage.removeItem("user-token"); // clear your user's token from localstorage
        resolve();
      });
    },
    SEND_SMS: ({ dispatch }, obj) => {
      return new Promise((resolve, reject) => {
        HTTP2.post("/sms", obj)
          .then((resp) => {
            resolve(resp);
            dispatch("get_sms_data", { customer: obj.customer });
          })
          .catch((err) => {
            reject(err);
          });
      });
    },

    getBookingByQuery({ commit }, payload) {
      commit("LOADING_API", true);
      return new Promise((resolve, reject) => {
        HTTP.post("getBookingByQuery", payload)
          .then((result) => {
            // HTTP2.get('tickets/' + payload.id).then(result => {
            commit("LOADING_API", false);
            resolve(result.data);
          })
          .catch((error) => {
            // throw new Error(`API ${error}`);
            if (error.response) {
              commit("LOADING_API", false);
              reject(error);
            } else {
              commit("LOADING_API", false);
              throw new Error(`API ${error}`);
              // commit('LOADING_API', false);
            }
          });
      });
    },
    getPaymentTickets({ commit }, payload) {
      commit("LOADING_API", true);
      return new Promise((resolve, reject) => {
        HTTP2.get("tickets", payload)
          .then((result) => {
            // HTTP2.get('tickets/' + payload.id).then(result => {
            commit("LOADING_API", false);
            commit("GET_PAYMENT_TICKET", result.data);
            resolve(result.data);
          })
          .catch((error) => {
            // throw new Error(`API ${error}`);
            if (error.response) {
              commit("LOADING_API", false);
              reject(error);
            } else {
              commit("LOADING_API", false);
              throw new Error(`API ${error}`);
            }
          });
      });
    },
    getTicketsOverview({ commit }) {
      commit("LOADING_API", true);
      return new Promise((resolve, reject) => {
        HTTP2.get("tickets/overview")
          .then((result) => {
            // HTTP2.get('tickets/' + payload.id).then(result => {
            commit("LOADING_API", false);
            commit("GET_PAYMENT_TICKET_OVERVIEW", result.data);
            resolve(result.data);
          })
          .catch((error) => {
            // throw new Error(`API ${error}`);
            if (error.response) {
              commit("LOADING_API", false);
              reject(error);
            } else {
              commit("LOADING_API", false);
              throw new Error(`API ${error}`);
              // commit('LOADING_API', false);
            }
          });
      });
    },
    loadHomePageData({ commit }, payload) {
      commit("LOADING_API", true);
      return new Promise((resolve, reject) => {
        HTTP2.get("webhooks/wp/home", payload)
          .then((result) => {
            // HTTP2.get('tickets/' + payload.id).then(result => {
            commit("LOADING_API", false);
            commit("GET_HOMEPAGE_DATA", result.data);
            resolve(result.data);
          })
          .catch((error) => {
            // throw new Error(`API ${error}`);
            if (error.response) {
              commit("LOADING_API", false);
              reject(error);
            } else {
              commit("LOADING_API", false);
              throw new Error(`API ${error}`);
              // commit('LOADING_API', false);
            }
          });
      });
    },
    updateHomePageData({ commit, dispatch }, payload) {
      const id = payload.id;
      const whereClause = payload.whereClause;
      delete payload["id"];
      delete payload["whereClause"];
      commit("LOADING_API", true);
      return new Promise((resolve, reject) => {
        HTTP2.post("webhooks/wp/home/" + id, payload)
          .then((result) => {
            // HTTP2.get('tickets/' + payload.id).then(result => {
            commit("LOADING_API", false);
            dispatch("loadHomePageData", {
              params: whereClause,
            });
            resolve(result);
          })
          .catch((error) => {
            // throw new Error(`API ${error}`);
            if (error.response) {
              commit("LOADING_API", false);
              reject(error);
            } else {
              commit("LOADING_API", false);
              throw new Error(`API ${error}`);
              // commit('LOADING_API', false);
            }
          });
      });
    },
    getTicketsById({ commit }, payload) {
      commit("LOADING_API", true);
      return new Promise((resolve, reject) => {
        HTTP2.get("tickets/" + payload.id)
          .then((result) => {
            // HTTP2.get('tickets/' + payload.id).then(result => {
            commit("LOADING_API", false);
            commit("GET_PAYMENT_TICKET_BY_ID", result.data);
            resolve(result.data);
          })
          .catch((error) => {
            // throw new Error(`API ${error}`);
            if (error.response) {
              commit("LOADING_API", false);
              reject(error);
            } else {
              commit("LOADING_API", false);
              throw new Error(`API ${error}`);
              // commit('LOADING_API', false);
            }
          });
      });
    },
    getRetrievalPaymentById({ commit }, payload) {
      commit("LOADING_API", true);
      return new Promise((resolve, reject) => {
        HTTP2.get("tickets/" + payload.id + "/payment")
          .then((result) => {
            // HTTP2.get('tickets/' + payload.id).then(result => {
            commit("LOADING_API", false);
            commit("GET_RETRIEVAL_PAYMENT_BY_ID", result.data);
            resolve(result.data);
          })
          .catch((error) => {
            // throw new Error(`API ${error}`);
            if (error.response) {
              commit("LOADING_API", false);
              reject(error);
            } else {
              commit("LOADING_API", false);
              throw new Error(`API ${error}`);
              // commit('LOADING_API', false);
            }
          });
      });
    },
    createPaymentTickets({ commit }, payload) {
      commit("LOADING_API", true);
      return new Promise((resolve, reject) => {
        HTTP2.post("tickets", payload)
          .then((result) => {
            commit("LOADING_API", false);
            resolve(result.data);
          })
          .catch((error) => {
            // throw new Error(`API ${error}`);
            if (error.response) {
              commit("LOADING_API", false);
              reject(error);
            } else {
              commit("LOADING_API", false);
              throw new Error(`API ${error}`);
              // commit('LOADING_API', false);
            }
          });
      });
    },
    adjustPaymentTickets({ commit }, payload) {
      var id = payload.ticketId;
      commit("LOADING_API", true);
      return new Promise((resolve, reject) => {
        HTTP2.post("tickets/" + id + "/payment", payload)
          .then((result) => {
            commit("LOADING_API", false);
            resolve(result.data);
          })
          .catch((error) => {
            // throw new Error(`API ${error}`);
            if (error.response) {
              commit("LOADING_API", false);
              reject(error);
            } else {
              commit("LOADING_API", false);
              throw new Error(`API ${error}`);
              // commit('LOADING_API', false);
            }
          });
      });
    },
    change_booking_flag: ({ commit, dispatch }, obj) => {
      return new Promise((resolve, reject) => {
        if (obj.dispatch) {
          var dispatchMutation = obj.dispatch;
        }
        if (obj.dispatchPayload) {
          var dispatchPayload = obj.dispatchPayload;
        }
        var bookingId = obj.bookingId;
        var funnelUrl = obj.funnelUrl;
        delete obj["dispatch"];
        delete obj["funnelUrl"];
        delete obj["bookingId"];
        delete obj["dispatchPayload"];
        commit("LOADING_API", true);
        HTTP2.post("/" + funnelUrl + "/" + bookingId + "/flag", obj)
          .then((resp) => {
            resolve(resp);
            // dispatch('get_agent_comment_data', {id: obj.customer})
            commit("CHANGE_STATUS_MODAL_TOGGLE", false);
            if (dispatchPayload) {
              dispatch(dispatchMutation, dispatchPayload);
            } else {
              dispatch(dispatchMutation);
            }
            if (dispatchMutation === "get_extension_failure_data") {
              dispatch("get_extension_failure_data_count");
            }
            commit("LOADING_API", false);
          })
          .catch((err) => {
            reject(err);
            commit("LOADING_API", false);
          });
      });
    },
    get_agent_comment_data({ commit }, payload) {
      commit("LOADING_API", true);
      HTTP.post("getAgentCommentData", {
        bookingId: payload.id,
      })
        .then((result) => {
          commit("AGENT_COMMENT_DATA", result.data);
          commit("LOADING_API", false);
        })
        .catch((error) => {
          commit("LOADING_API", false);
          throw new Error(`API ${error}`);
        });
    },
    create_template: ({ dispatch }, obj) => {
      return new Promise((resolve, reject) => {
        HTTP2.post("/flow", obj)
          .then((resp) => {
            resolve(resp);
            dispatch("get_template_data");
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    delete_template: ({ dispatch }, obj) => {
      return new Promise((resolve, reject) => {
        HTTP2.delete("/flow/" + obj.id)
          .then((resp) => {
            resolve(resp);
            dispatch("get_template_data", {});
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    edit_template: ({ dispatch }, obj) => {
      var id = obj.id;
      delete obj.id;
      return new Promise((resolve, reject) => {
        HTTP2.post("/flow/" + id, obj)
          .then((resp) => {
            resolve(resp);
            dispatch("get_template_data", {});
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    get_template_data({ commit }, payload) {
      var queryString = {
        limit: 100,
      };
      if (payload.start && payload.end) {
        queryString.start = payload.start;
        queryString.end = payload.end;
      }
      commit("LOADING_API", true);
      HTTP2.get("flow", {
        params: queryString,
      })
        .then((result) => {
          commit("GET_TEMPLATE_DATA", result.data);
          commit("LOADING_API", false);
        })
        .catch((error) => {
          commit("LOADING_API", false);
          throw new Error(`API ${error}`);
        });
    },
    get_idfc_loan_data({ commit }) {
      var queryString = {
        limit: 100,
      };
      commit("LOADING_API", true);
      HTTP2.get("idfc/loan", {
        params: queryString,
      })
        .then((result) => {
          commit("GET_IDFC_LOAN_DATA", result.data);
          commit("LOADING_API", false);
        })
        .catch((error) => {
          commit("LOADING_API", false);
          throw new Error(`API ${error}`);
        });
    },
    get_extension_failure_data({ commit }, payload) {
      var queryString = {
        flag: payload.flag,
        failed: payload.failed,
        limit: payload.limit,
      };
      if (payload.start && payload.end) {
        queryString.start = payload.start;
        queryString.end = payload.end;
      }
      commit("LOADING_API", true);
      return new Promise((resolve, reject) => {
        HTTP2.get("booking/payment/extension", {
          params: queryString,
        })
          .then((result) => {
            resolve(result.data);
            commit("GET_EXTENSION_PAYMENT_FAILURE", result.data);
            commit("LOADING_API", false);
          })
          .catch((error) => {
            reject(error);
            throw new Error(`API ${error}`);
          });
      });
    },
    get_sms_data({ commit }, payload) {
      var queryString = {
        customer: payload.customer,
      };
      if (payload.start && payload.end) {
        queryString.start = payload.start;
        queryString.end = payload.end;
      }
      commit("LOADING_API", true);
      HTTP2.get("sms/log", {
        params: queryString,
      })
        .then((result) => {
          commit("GET_SMS_DATA", result.data);
          commit("LOADING_API", false);
        })
        .catch((error) => {
          commit("LOADING_API", false);
          throw new Error(`API ${error}`);
        });
    },
    get_extension_failure_data_count({ commit }) {
      // var queryString = {
      //   flag: payload.flag,
      //   failed: payload.failed,
      //   limit: payload.limit
      // }
      // if (payload.start && payload.end){
      //   queryString.start = payload.start
      //   queryString.end = payload.end
      // }
      commit("LOADING_API", true);
      HTTP2.get(
        "booking/payment/extension/count?failed=true&flag=0&flag=1&flag=2&flag=3"
      )
        .then((result) => {
          commit("GET_EXTENSION_PAYMENT_FAILURE_COUNT", result.data);
          commit("LOADING_API", false);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
    },
    get_agents({ commit }) {
      commit("LOADING_API", true);

      axios
        .get(this.getters.baseUrl + "getAgents?status=1", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
          },
        })
        .then((result) => {
          commit("GET_AGENT", result.data);
          commit("LOADING_API", false);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
    },
    get_customerbyname({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit("LOADING_API", true);
        axios
          .post(
            this.getters.baseUrl + "searchCustomer",
            {
              params: payload.phone,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
              },
            }
          )
          .then((result) => {
            commit("LOADING_API", false);
            commit("GET_CX_BY_NUM", result.data);
            resolve(result);
          })
          .catch((error) => {
            // throw new Error(`API ${error}`);
            if (error.response) {
              alert("Something is wrong with API");

              reject();
            } else {
              alert(error.message);

              reject();
            }
          });
      });
    },
    searchSEO({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit("LOADING_API", false);
        axios
          .post(
            this.getters.baseUrl + "searchCustomer",
            {
              params: payload.phone,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
              },
            }
          )
          .then((result) => {
            commit("LOADING_API", false);
            commit("searchSEO", result.data);
            resolve();
          })
          .catch((error) => {
            // throw new Error(`API ${error}`);
            if (error.response) {
              alert("Something is wrong with API");

              reject();
            } else {
              alert(error.message);

              reject();
            }
          });
      });
    },
    get_customer_activity({ commit }, payload) {
      commit("LOADING_API", true);
      axios
        .post(
          this.getters.baseUrl + "getCustomerActivity",
          {
            customerId: payload.id,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then((result) => {
          commit("LOADING_API", false);
          commit("GET_CX_ACTIVITY", result.data);
        })
        .catch((error) => {
          // throw new Error(`API ${error}`);
          if (error.response) {
            alert("Something is wrong with API");
          } else {
            alert(error.message);
          }
        });
    },
    get_customer_waitlist({ commit }, payload) {
      commit("LOADING_API", true);
      axios
        .post(
          this.getters.baseUrl + "getWaitByCustomer",
          {
            customer: payload.id,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then((result) => {
          commit("LOADING_API", false);
          commit("GET_CX_WAITLIST", result.data);
        })
        .catch((error) => {
          // throw new Error(`API ${error}`);
          if (error.response) {
            alert("Something is wrong with API");
          } else {
            alert(error.message);
          }
        });
    },
    get_customer_coupon_history({ commit }, payload) {
      commit("LOADING_API", true);
      axios
        .post(
          this.getters.baseUrl + "getCouponHistory",
          {
            customer: payload.id,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then((result) => {
          commit("LOADING_API", false);
          commit("GET_CX_COUPON_HISTORY", result.data);
        })
        .catch((error) => {
          // throw new Error(`API ${error}`);
          if (error.response) {
            alert("Something is wrong with API");
          } else {
            alert(error.message);
          }
        });
    },
    get_customer_collection_history({ commit }, payload) {
      commit("LOADING_API", true);
      axios
        .post(
          this.getters.baseUrl + "getCollectionListbyCustomer",
          {
            customer: payload.id,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then((result) => {
          commit("LOADING_API", false);
          commit("GET_CX_COLLECTION_HISTORY", result.data);
        })
        .catch((error) => {
          // throw new Error(`API ${error}`);
          if (error.response) {
            alert("Something is wrong with API");
          } else {
            alert(error.message);
          }
        });
    },
    getAgentsActivity({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit("LOADING_API", true);
        axios
          .post(
            this.getters.baseUrl + "getAgentsActivity",
            {
              bookingId: payload.id,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
              },
            }
          )
          .then((result) => {
            resolve(result);
            commit("LOADING_API", false);
            commit("GET_AGENT_ACTIVITY", result.data);
          })
          .catch((error) => {
            // throw new Error(`API ${error}`);
            reject(error);
            if (error.response) {
              alert("Something is wrong with API");
            } else {
              alert(error.message);
            }
          });
      });
    },
    get_customer_points({ commit }, payload) {
      commit("LOADING_API", true);
      axios
        .post(
          this.getters.baseUrl + "getReferalPoints",
          {
            id: payload.id,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then((result) => {
          commit("LOADING_API", false);
          commit("GET_CX_POINTS", result.data);
        })
        .catch((error) => {
          // throw new Error(`API ${error}`);
          if (error.response) {
            alert("Something is wrong with API");
          } else {
            alert(error.message);
          }
        });
    },
    get_vehicle_count({ commit }) {
      return new Promise((resolve, reject) => {
        commit("LOADING_API", true);
        axios
          .get(this.getters.baseUrl + "getModels", {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          })
          .then((result) => {
            commit("VEHICLE_COUNT", result.data);
            commit("LOADING_API", false);
            resolve(result.data);
          })
          .catch((error) => {
            reject(error);
            throw new Error(`API ${error}`);
          });
      });
    },
    get_customerData({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit("LOADING_API", true);
        axios
          .get(this.getters.baseUrl + "customer/" + payload.id, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          })
          .then((result) => {
            commit("LOADING_API", false);
            commit("GET_CX_DATA", result.data);
            resolve(result.data);
          })
          .catch((error) => {
            // throw new Error(`API ${error}`);
            reject(error);
            if (error.response) {
              alert("Something is wrong with API");
            } else {
              alert(error.message);
            }
          });
      });
    },
    get_customers({ commit }) {
      commit("LOADING_API", true);
      axios
        .get(this.getters.baseUrl + "getVendor", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
          },
        })
        .then((result) => {
          commit("GET_CX", result);
          commit("LOADING_API", false);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
    },
    notes({ commit }) {
      commit("LOADING_API", true);
      axios
        .post(
          this.getters.baseUrl + "readNotes",
          {},
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then((result) => {
          commit("GET_NOTES", result.data);
          commit("LOADING_API", false);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
    },
    sucess_source_list({ commit }) {
      return new Promise((resolve, reject) => {
        commit("LOADING_API", true);
        axios
          .post(
            this.getters.baseUrl + "bookingSuccessCount",
            {},
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
              },
            }
          )
          .then((result) => {
            commit("GET_SUCESS_SOURCE_COUNT", result.data);
            commit("LOADING_API", false);
            resolve(result.data);
          })
          .catch((error) => {
            reject(error);
            throw new Error(`API ${error}`);
          });
      });
    },
    fail_source_list({ commit }) {
      return new Promise((resolve, reject) => {
        commit("LOADING_API", true);
        axios
          .post(
            this.getters.baseUrl + "bookingFailureCount",
            {},
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
              },
            }
          )
          .then((result) => {
            resolve(result.data);
            commit("GET_FAIL_SOURCE_COUNT", result.data);
            commit("LOADING_API", false);
          })
          .catch((error) => {
            reject(error);
            throw new Error(`API ${error}`);
          });
      });
    },
    sucess_by_date({ commit }, payload) {
      commit("LOADING_API", true);
      axios
        .post(
          this.getters.baseUrl + "bookingSucessCountByDate",
          {
            startDate: payload.startDate,
            endDate: payload.endDate,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then((result) => {
          commit("GET_SUCESS_BY_DATES", result.data);
          commit("LOADING_API", false);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
    },
    get_waitlist({ commit }) {
      commit("LOADING_API", true);
      axios
        .post(
          this.getters.baseUrl + "waitlistQuery",
          {},
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then((result) => {
          commit("LOADING_API", false);
          commit("GET_WAITLIST", result.data);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
    },
    get_drop_vehicle({ commit }) {
      commit("LOADING_API", true);
      axios
        .post(
          this.getters.baseUrl +
            "droppedVehicle?endDate=" +
            this.getters.yesterday,
          {},
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then((result) => {
          commit("LOADING_API", false);
          commit("GET_DROP_VEHICLE", result.data);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
    },
    get_service_request({ commit }, payload) {
      commit("LOADING_API", true);
      axios
        .post(
          this.getters.baseUrl + "getServiceListByQuerywithCustomer",
          {
            status: payload.status,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then((result) => {
          commit("LOADING_API", false);
          commit("GET_SERVICE_REQUEST", result.data);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
      commit("LOADING_API", false);
    },
    get_loan_request({ commit }, payload) {
      commit("LOADING_API", true);
      axios
        .post(
          "https://glacier.on-track.in/api/ontrack-loan-enquiry/get-by-status",
          {
            status: payload.status,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "YwMiRtYxQpVcMsVy1w3Z9==",
            },
          }
        )
        .then((result) => {
          commit("LOADING_API", false);
          commit("GET_LOAN_REQUEST", result.data);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
      commit("LOADING_API", false);
    },
    get_shop_lead({ commit }, payload) {
      commit("LOADING_API", true);
      axios
        .post(
          "https://glacier.on-track.in/api/shop_outreach/get-by-status",
          {
            status: payload.status,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "YwMiRtYxQpVcMsVy1w3Z9==",
            },
          }
        )
        .then((result) => {
          commit("LOADING_API", false);
          commit("GET_SHOP_LEAD", result.data);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
      commit("LOADING_API", false);
    },

    get_shop_interested({ commit }, payload) {
      commit("LOADING_API", true);
      axios
        .post(
          "https://glacier.on-track.in/api/otr_customer_interest/get-by-status",
          {
            status: payload.status,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "YwMiRtYxQpVcMsVy1w3Z9==",
            },
          }
        )
        .then((result) => {
          commit("LOADING_API", false);
          commit("GET_SHOP_INTERESTED", result.data);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
      commit("LOADING_API", false);
    },

    get_loan_request_count({ commit }) {
      commit("LOADING_API", true);
      axios
        .get(
          "https://glacier.on-track.in/api/ontrack-loan-enquiry/get-count-by-status",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "YwMiRtYxQpVcMsVy1w3Z9==",
            },
          }
        )
        .then((result) => {
          commit("LOADING_API", false);
          commit("LOAN_REQUEST_COUNT", result.data);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
      commit("LOADING_API", false);
    },
    get_loan_against_vehicle_count({ commit }) {
      commit("LOADING_API", true);
      axios
        .get(
          "https://glacier.on-track.in/api/loan_against_vehicle/get-count-by-status",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "YwMiRtYxQpVcMsVy1w3Z9==",
            },
          }
        )
        .then((result) => {
          commit("LOADING_API", false);
          commit("LOAN_AGAINST_VEHICLE_COUNT", result.data);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
      commit("LOADING_API", false);
    },

    get_loan_against_vehicle({ commit }, payload) {
      commit("LOADING_API", true);
      axios
        .post(
          "https://glacier.on-track.in/api/loan_against_vehicle/get-by-status",
          {
            status: payload.status,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "YwMiRtYxQpVcMsVy1w3Z9==",
            },
          }
        )
        .then((result) => {
          commit("LOADING_API", false);
          commit("GET_LOAN_AGAINST_VEHICLE", result.data);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
      commit("LOADING_API", false);
    },

    two_wheeler_loan_count({ commit }) {
      commit("LOADING_API", true);
      axios
        .get("https://glacier.on-track.in/api/bike_loan/get-count-by-status", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "YwMiRtYxQpVcMsVy1w3Z9==",
          },
        })
        .then((result) => {
          commit("LOADING_API", false);
          commit("TWO_WHEELER_LOAN_COUNT", result.data);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
      commit("LOADING_API", false);
    },

    two_wheeler_loan({ commit }, payload) {
      commit("LOADING_API", true);
      axios
        .post(
          "https://glacier.on-track.in/api/bike_loan/get-by-status",
          {
            status: payload.status,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "YwMiRtYxQpVcMsVy1w3Z9==",
            },
          }
        )
        .then((result) => {
          commit("LOADING_API", false);
          commit("TWO_WHEELER_LOAN", result.data);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
      commit("LOADING_API", false);
    },
    get_otr_purchase_success({ commit }, payload) {
      commit("LOADING_API", true);
      axios
        .post(
          "https://glacier.on-track.in/api/otr_purchase/fetch-order-data/sucess",
          {
            status: payload.status,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "YwMiRtYxQpVcMsVy1w3Z9==",
            },
          }
        )
        .then((result) => {
          commit("LOADING_API", false);
          commit("GET_OTR_PURCHASE_SUCESS", result.data);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
      commit("LOADING_API", false);
    },
    get_otr_purchase_failed({ commit }, payload) {
      commit("LOADING_API", true);
      axios
        .post(
          "https://glacier.on-track.in/api/otr_purchase/fetch-order-data/failure",
          {
            status: payload.status,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "YwMiRtYxQpVcMsVy1w3Z9==",
            },
          }
        )
        .then((result) => {
          commit("LOADING_API", false);
          commit("GET_OTR_PURCHASE_FAILED", result.data);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
      commit("LOADING_API", false);
    },
    get_booking_by_date({ commit }) {
      commit("LOADING_API", true);
      axios
        .post(
          this.getters.baseUrl + "booking/1?endDate=" + this.getters.yesterday,
          {},
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then((result) => {
          commit("LOADING_API", false);
          commit("GET_BOOKING_BY_DATE", result.data);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
    },
    get_drop_vehicle_byDate({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit("LOADING_API", true);
        axios
          .post(
            this.getters.baseUrl + "droppedVehicle?endDate=" + payload.date,
            {},
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
              },
            }
          )
          .then((result) => {
            resolve(result.data);
            commit("GET_DROP_VEHICLE_BY_DATE", result.data);
            commit("LOADING_API", false);
          })
          .catch((error) => {
            reject(error);
            throw new Error(`API ${error}`);
          });
      });
    },

    get_drop_vehicle_between_dates({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit("LOADING_API", true);
        axios
          .post(
            this.getters.baseUrl + "droppedVehicleByWeek",
            {
              start: payload.start,
              end: payload.end,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
              },
            }
          )
          .then((result) => {
            commit("GET_DROP_VEHICLE_BETWEEN_DATE", result.data);
            commit("LOADING_API", false);
            resolve(result);
          })
          .catch((error) => {
            reject(error);
            throw new Error(`API ${error}`);
          });
      });
    },

    get_extend_payment_data({ commit }, payload) {
      commit("LOADING_API", true);
      HTTP2.post("crm/getextensions", {
        customerId: payload.id,
      })
        .then((result) => {
          commit("GET_EXTEND_PAYMENT_DATA", result.data);
          commit("LOADING_API", false);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
    },

    get_pickup_vehicle_between_dates({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit("LOADING_API", true);
        axios
          .post(
            this.getters.baseUrl + "pickupVehicleByWeek",
            {
              start: payload.start,
              end: payload.end,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
              },
            }
          )
          .then((result) => {
            resolve(result);
            commit("GET_PICKUP_VEHICLE_BETWEEN_DATE", result.data);
            commit("LOADING_API", false);
          })
          .catch((error) => {
            reject(error);
            throw new Error(`API ${error}`);
          });
      });
    },

    get_new_customers({ commit }, payload) {
      commit("LOADING_API", true);
      axios
        .post(
          this.getters.baseUrl + "newUsersByDay?createdAt=" + payload.date,
          {},
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then((result) => {
          commit("LOADING_API", false);
          commit("GET_NEW_CUSTOMERS", result.data);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
    },
    get_total_vehicles({ commit }) {
      commit("LOADING_API", true);
      axios
        .get(this.getters.baseUrl + "getVehicles", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
          },
        })
        .then((result) => {
          commit("LOADING_API", false);
          commit("GET_TOTAL_VEHICLES", result.data);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
    },
    get_booking_history({ commit }, payload) {
      commit("LOADING_API", true);
      axios
        .post(
          this.getters.baseUrl + "getBookingByQueryWithAgentActivity",
          {
            customer: payload.id,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then((result) => {
          commit("LOADING_API", false);
          commit("GET_BOOKING_HISTORY", result.data);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
    },
    get_point_ledger({ commit }, payload) {
      commit("LOADING_API", true);
      axios
        .post(
          this.getters.baseUrl + "getPointsLedger",
          {
            id: payload.id,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then((result) => {
          commit("LOADING_API", false);
          commit("GET_POINT_LEDGER", result.data);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
    },
    get_booking_by_id({ commit }, payload) {
      commit("LOADING_API", true);
      axios
        .post(
          this.getters.baseUrl + "getBookingById",
          {
            id: payload.id,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
            },
          }
        )
        .then((result) => {
          commit("LOADING_API", false);
          commit("GET_BOOKING_BY_ID", result.data);
        })
        .catch((error) => {
          // throw new Error(`API ${error}`);
          if (error.response) {
            this.$toasted.global.my_app_error();
          } else {
            this.$toasted.global.my_app_error();
          }
        });
    },
    get_new_bookings({ commit }) {
      return new Promise((resolve, reject) => {
        commit("LOADING_API", true);
        axios
          .post(
            this.getters.baseUrl + "getBookingByQuery",
            {
              status: 0,
              paymentStatus: 1,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
              },
            }
          )
          .then((result) => {
            resolve(result);
            commit("LOADING_API", false);
            commit("GET_NEW_BOOKING", result.data);
          })
          .catch((error) => {
            reject(error);
            throw new Error(`API ${error}`);
          });
      });
    },
    get_expired_bookings({ commit }) {
      commit("LOADING_API", true);
      return new Promise((resolve, reject) => {
        axios
          .post(
            this.getters.baseUrl + "getBookingByQuery",
            {
              status: 3,
              paymentStatus: 1,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
              },
            }
          )
          .then((result) => {
            commit("LOADING_API", false);
            commit("GET_EXPIRED_BOOKING", result.data);
            resolve(result);
          })
          .catch((error) => {
            reject(error);
            throw new Error(`API ${error}`);
          });
      });
    },

    get_bookings_date({ commit }, payload) {
      return new Promise((resolve, reject) => {
        commit("LOADING_API", true);
        axios
          .post(
            this.getters.baseUrl + "getPlusBookingsByendDate",
            {
              date: payload.date,
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
              },
            }
          )
          .then((result) => {
            commit("LOADING_API", false);
            commit("GET_BOOKING_DATE", result.data);
            resolve(result.data);
          })
          .catch((error) => {
            reject(error);
            throw new Error(`API ${error}`);
          });
      });
    },

    get_failed_booking({ commit }) {
      return new Promise((resolve, reject) => {
        commit("LOADING_API", true);
        axios
          .post(
            this.getters.baseUrl + "getBookingByQuery",
            // {
            //   status: 0,
            //   paymentStatus: null
            // },
            {
              status: 0,
              or: [
                {
                  paymentStatus: 0,
                },
                {
                  paymentStatus: null,
                },
              ],
            },
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
              },
            }
          )
          .then((result) => {
            resolve(result.data);
            commit("LOADING_API", false);
            commit("GET_FAILED_BOOKING", result.data);
          })
          .catch((error) => {
            reject(error);
            throw new Error(`API ${error}`);
          });
      });
    },
    get_squad_data({ commit }) {
      commit("LOADING_API", true);
      axios
        .get("https://glacier.on-track.in/api/squadVoice/", {})
        .then((result) => {
          commit("LOADING_API", false);
          commit("SQUAD_DATA", result.data);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
    },
    get_traffic_violation({ commit }, payload) {
      commit("LOADING_API", true);
      axios
        .get(
          "https://glacier.on-track.in/api/vehicle/" +
            payload.registrationNumber +
            "/violation",
          {}
        )
        .then((result) => {
          commit("LOADING_API", false);
          commit("TRAFFIC_VIOLATION", result.data);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
    },
    get_models({ commit }) {
      commit("LOADING_API", true);
      axios
        .get(this.getters.baseUrl + "getModels", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Basic YWRtaW5BdXRoOnZpc2h1QDE5OTI=",
          },
        })
        .then((result) => {
          commit("LOADING_API", false);
          commit("GET_MODELS", result.data);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
    },
    get_Knowlarity_data({ commit }, payload) {
      commit("LOADING_API", true);
      axios
        .get(
          "https://kpi.knowlarity.com/Basic/v1/account/calllog?start_time=" +
            payload.startDate +
            "&end_time=" +
            payload.endDate +
            "&agent_number=" +
            payload.agentNumber +
            "&limit=" +
            payload.limit +
            "&offset=" +
            payload.offset,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "e3dce252-7fb2-4a9f-9df7-24c1260bc9d3",
              "x-api-key": "WLt7gg1bF02glZihlGwOB4V1bAifEQgd7Rnzaxil",
            },
          }
        )
        .then((result) => {
          commit("LOADING_API", false);
          commit("GET_KNOWLARITY_DATA", result.data);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
    },
    get_knowlarity_data_by_phone({ commit }, payload) {
      commit("LOADING_API", true);
      axios
        .get(
          "https://kpi.knowlarity.com/Basic/v1/account/calllog?start_time=2020-02-09&end_time=" +
            payload.endDate +
            "&customer_number=" +
            payload.customerNumber +
            "&limit=100",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "e3dce252-7fb2-4a9f-9df7-24c1260bc9d3",
              "x-api-key": "WLt7gg1bF02glZihlGwOB4V1bAifEQgd7Rnzaxil",
            },
          }
        )
        .then((result) => {
          commit("LOADING_API", false);
          commit("GET_KNOWLARITY_DATA_BY_PHONE", result.data.objects);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
    },
    // get_missed_call_data({ commit }, payload) {
    //   commit("LOADING_API", true);
    //   axios
    //     .get("https://kpi.knowlarity.com/Basic/v1/account/calllog?start_time="+payload.startDate+"&end_time="+payload.endDate+"&agent_number="+payload.agentNumber+"&limit="+payload.limit+"&offset="+payload.offset, {
    //       headers: {
    //         "Content-Type": "application/json",
    //         Authorization: "e3dce252-7fb2-4a9f-9df7-24c1260bc9d3",
    //         "x-api-key":"WLt7gg1bF02glZihlGwOB4V1bAifEQgd7Rnzaxil"
    //       },
    //     })
    //     .then((result) => {
    //       commit("LOADING_API", false);
    //       commit("GET_MISSED_CALL_DATA", result.data);
    //     })
    //     .catch((error) => {
    //       throw new Error(`API ${error}`);
    //     });
    // },
    get_Knowlarity_agents({ commit }) {
      commit("LOADING_API", true);
      axios
        .get("https://kpi.knowlarity.com/Basic/v1/account/agent", {
          headers: {
            "Content-Type": "application/json",
            Authorization: "e3dce252-7fb2-4a9f-9df7-24c1260bc9d3",
            "x-api-key": "WLt7gg1bF02glZihlGwOB4V1bAifEQgd7Rnzaxil",
          },
        })
        .then((result) => {
          commit("LOADING_API", false);
          commit("GET_KNOWLARITY_AGENTS", result.data.objects);
        })
        .catch((error) => {
          throw new Error(`API ${error}`);
        });
    },
    get_reminder({ commit }) {
      commit("LOADING_API", true);
      window.db
        .collection("reminder")
        .where("reminder_date", "==", this.getters.date)
        .onSnapshot((querySnapshot) => {
          let allMessages = [];
          querySnapshot.forEach((doc) => {
            allMessages.push(doc.data());
          });
          commit("LOADING_API", false);
          commit("GET_REMINDER", allMessages);
        });
    },
    get_due_pay({ commit }) {
      commit("LOADING_API", true);
      window.db.collection("paymentDue").onSnapshot((querySnapshot) => {
        let allDueList = [];
        querySnapshot.forEach((doc) => {
          allDueList.push(doc.data());
        });
        commit("LOADING_API", false);
        commit("GET_DUE_PAY", allDueList);
      });
    },
    get_reminder_count({ commit }) {
      commit("LOADING_API", true);
      window.db
        .collection("reminder")
        .where("reminder_date", "==", this.getters.date)
        .where("read", "==", 0)
        .onSnapshot((querySnapshot) => {
          let allMessages = [];
          querySnapshot.forEach((doc) => {
            allMessages.push(doc.data());
          });
          commit("LOADING_API", false);
          commit("GET_REMINDER_COUNT", allMessages.length);
        });
    },
    get_chat_count({ commit }) {
      commit("LOADING_API", true);
      window.db
        .collection("messages")
        .where("seen", "==", 0)
        .onSnapshot((querySnapshot) => {
          let allMessages = [];
          querySnapshot.forEach((doc) => {
            if (doc.data().agent_id == Number(this.getters.agent_id)) {
              return false;
            } else {
              allMessages.push(doc.data());
            }
          });
          commit("LOADING_API", false);
          commit("GET_MESSAGES_COUNT", allMessages.length);
        });
    },
  },
  getters: {
    baseUrl() {
      return "https://api.on-track.in/api/";
    },
    getTemplate() {
      return templates;
    },
    baseUrlv2() {
      return "https://glacier.on-track.in/api/";
    },
    userName(state) {
      return localStorage.getItem("username") || state.userName;
    },
    waitlistdata(state) {
      return (id) =>
        _.filter(_.uniqBy(state.waitlist, "mobile"), function(o) {
          return o.flag == id;
        });
    },
    newServiceData(state) {
      return (id) =>
        _.filter(_.uniqBy(state.service_request, "customer"), function(o) {
          return o.status == id;
        });
    },
    newCustomerdata(state) {
      return (id) =>
        _.filter(_.uniqBy(state.new_customers, "mobile"), function(o) {
          return o.flag == id;
        });
    },
    failed_booking_data(state) {
      return (id) =>
        _.filter(_.uniqBy(state.failed_bookings, "customerMobile"), function(
          o
        ) {
          return o.flag == id;
        });
    },
    drop_vehicle_data(state) {
      return (id) =>
        _.filter(_.uniqBy(state.dropped_vehicle_by_date, "mobile"), function(
          o
        ) {
          if (id == 0) {
            return (
              o.flag != 7 &&
              o.flag != 8 &&
              o.flag != 9 &&
              o.flag != 11 &&
              o.flag != 12
            );
          } else {
            return o.flag === id;
          }
        });
    },
    new_booking(state) {
      return (id) =>
        _.filter(_.uniqBy(state.new_bookings, "customerMobile"), function(o) {
          return o.flag === id;
        });
    },
    expired_booking(state) {
      return (id) =>
        _.filter(_.uniqBy(state.expired_bookings, "customerMobile"), function(
          o
        ) {
          if (id == 0) {
            return (
              o.flag != 5 &&
              o.flag != 6 &&
              o.flag != 10 &&
              o.flag != 50 &&
              o.flag != 51 &&
              o.flag != 17
            );
          } else {
            return o.flag === id;
          }
        });
    },
    plus_booking(state) {
      return (id) =>
        _.filter(_.uniqBy(state.booking_date, "mobile"), function(o) {
          if (id == 0) {
            return o.flag != 3 && o.flag != 4;
          } else {
            return o.flag === id;
          }
          // return o.flag === id
        });
    },
    // demo(state){
    //   return _.uniqBy(state.waitlist, 'mobile').map((items) => ({ length: items.length }))
    // }

    // ,
    username() {
      return localStorage.getItem("username");
    },
    agent_id() {
      return Number(localStorage.getItem("agent_id"));
    },
    waitlist_count(state) {
      return {
        new: _.filter(_.uniqBy(state.waitlist, "mobile"), function(o) {
          return o.flag == 18 || null;
        }).length,
        postponed: _.filter(_.uniqBy(state.waitlist, "mobile"), function(o) {
          return o.flag == 19;
        }).length,
        action_taken: _.filter(_.uniqBy(state.waitlist, "mobile"), function(o) {
          return o.flag == 20;
        }).length,
        not_interested: _.filter(_.uniqBy(state.waitlist, "mobile"), function(
          o
        ) {
          return o.flag == 21;
        }).length,
        successful: _.filter(_.uniqBy(state.waitlist, "mobile"), function(o) {
          return o.flag == 22;
        }).length,
        squadVoice: _.filter(_.uniqBy(state.waitlist, "mobile"), function(o) {
          return o.flag == 10;
        }).length,
      };
    },
    service_count(state) {
      return {
        new: _.filter(_.uniqBy(state.service_request, "customer"), function(o) {
          return o.status == 0;
        }).length,
        postponed: _.filter(
          _.uniqBy(state.service_request, "customer"),
          function(o) {
            return o.status == 1;
          }
        ).length,
        action_taken: _.filter(
          _.uniqBy(state.service_request, "customer"),
          function(o) {
            return o.status == 2;
          }
        ).length,
        not_interested: _.filter(
          _.uniqBy(state.service_request, "customer"),
          function(o) {
            return o.status == 3;
          }
        ).length,
        successful: _.filter(
          _.uniqBy(state.service_request, "customer"),
          function(o) {
            return o.status == 4;
          }
        ).length,
        squadVoice: _.filter(
          _.uniqBy(state.service_request, "customer"),
          function(o) {
            return o.status == 10;
          }
        ).length,
      };
    },
    failed_booking_count(state) {
      return {
        new: _.filter(
          _.uniqBy(state.failed_bookings, "customerMobile"),
          function(o) {
            return o.flag == 0 || null;
          }
        ).length,
        postponed: _.filter(
          _.uniqBy(state.failed_bookings, "customerMobile"),
          function(o) {
            return o.flag === 13;
          }
        ).length,
        action_taken: _.filter(
          _.uniqBy(state.failed_bookings, "customerMobile"),
          function(o) {
            return o.flag == 14;
          }
        ).length,
        not_interested: _.filter(
          _.uniqBy(state.failed_bookings, "customerMobile"),
          function(o) {
            return o.flag == 15;
          }
        ).length,
        successful: _.filter(
          _.uniqBy(state.failed_bookings, "customerMobile"),
          function(o) {
            return o.flag == 16;
          }
        ).length,
        squadVoice: _.filter(
          _.uniqBy(state.failed_bookings, "customerMobile"),
          function(o) {
            return o.flag == 10;
          }
        ).length,
      };
    },

    new_cx_count(state) {
      return {
        new: _.filter(_.uniqBy(state.new_customers, "mobile"), function(o) {
          return o.flag == 0 || null;
        }).length,
        postponed: _.filter(_.uniqBy(state.new_customers, "mobile"), function(
          o
        ) {
          return o.flag == 1;
        }).length,
        successful: _.filter(_.uniqBy(state.new_customers, "mobile"), function(
          o
        ) {
          return o.flag == 4;
        }).length,
        squadVoice: _.filter(_.uniqBy(state.new_customers, "mobile"), function(
          o
        ) {
          return o.flag == 5;
        }).length,
      };
    },

    drop_vehicle_count(state) {
      return {
        new: _.filter(
          _.uniqBy(state.dropped_vehicle_by_date, "mobile"),
          function(o) {
            return (
              (o.flag != 7 &&
                o.flag != 8 &&
                o.flag != 9 &&
                o.flag != 11 &&
                o.flag != 12) ||
              null
            );
          }
        ).length,
        postponed: _.filter(
          _.uniqBy(state.dropped_vehicle_by_date, "mobile"),
          function(o) {
            return o.flag === 7;
          }
        ).length,
        action_taken: _.filter(
          _.uniqBy(state.dropped_vehicle_by_date, "mobile"),
          function(o) {
            return o.flag == 8;
          }
        ).length,
        not_interested: _.filter(
          _.uniqBy(state.dropped_vehicle_by_date, "mobile"),
          function(o) {
            return o.flag == 9;
          }
        ).length,
        successful: _.filter(
          _.uniqBy(state.dropped_vehicle_by_date, "mobile"),
          function(o) {
            return o.flag == 11;
          }
        ).length,
        satisfied: _.filter(
          _.uniqBy(state.dropped_vehicle_by_date, "mobile"),
          function(o) {
            return o.flag == 12;
          }
        ).length,
      };
    },
    drop_vehicle_count_yesterday(state) {
      return _.uniqBy(state.drop_vehicle, "mobile").length;
    },
    drop_vehicle_count_today(state) {
      return _.uniqBy(state.dropped_vehicle_by_date, "mobile").length;
    },
    new_bookings_count(state) {
      return {
        new: _.filter(_.uniqBy(state.new_bookings, "customerMobile"), function(
          o
        ) {
          return o.flag == 0 || null;
        }).length,
        postponed: _.filter(
          _.uniqBy(state.new_bookings, "customerMobile"),
          function(o) {
            return o.flag === 1;
          }
        ).length,
        action_taken: _.filter(
          _.uniqBy(state.new_bookings, "customerMobile"),
          function(o) {
            return o.flag == 2;
          }
        ).length,
        not_interested: _.filter(
          _.uniqBy(state.new_bookings, "customerMobile"),
          function(o) {
            return o.flag == 3;
          }
        ).length,
        successful: _.filter(
          _.uniqBy(state.new_bookings, "customerMobile"),
          function(o) {
            return o.flag == 4;
          }
        ).length,
        satisfied: _.filter(
          _.uniqBy(state.new_bookings, "customerMobile"),
          function(o) {
            return o.flag == 5;
          }
        ).length,
      };
    },
    expired_bookings_count(state) {
      return {
        new: _.filter(
          _.uniqBy(state.expired_bookings, "customerMobile"),
          function(o) {
            return (
              (o.flag != 5 &&
                o.flag != 6 &&
                o.flag != 10 &&
                o.flag != 50 &&
                o.flag != 51 &&
                o.flag != 17) ||
              null
            );
          }
        ).length,
        postponed: _.filter(
          _.uniqBy(state.expired_bookings, "customerMobile"),
          function(o) {
            return o.flag === 1;
          }
        ).length,
        action_taken: _.filter(
          _.uniqBy(state.expired_bookings, "customerMobile"),
          function(o) {
            return o.flag == 5;
          }
        ).length,
        not_interested: _.filter(
          _.uniqBy(state.expired_bookings, "customerMobile"),
          function(o) {
            return o.flag == 6;
          }
        ).length,
        successful: _.filter(
          _.uniqBy(state.expired_bookings, "customerMobile"),
          function(o) {
            return o.flag == 4;
          }
        ).length,
        satisfied: _.filter(
          _.uniqBy(state.expired_bookings, "customerMobile"),
          function(o) {
            return o.flag == 5;
          }
        ).length,
        sent_credgenics: _.filter(
          _.uniqBy(state.expired_bookings, "customerMobile"),
          function(o) {
            return o.flag == 10;
          }
        ).length,
        vehicle_lost: _.filter(
          _.uniqBy(state.expired_bookings, "customerMobile"),
          function(o) {
            return o.flag == 50;
          }
        ).length,
        at_station: _.filter(
          _.uniqBy(state.expired_bookings, "customerMobile"),
          function(o) {
            return o.flag == 51;
          }
        ).length,
        requested_pickup: _.filter(
          _.uniqBy(state.expired_bookings, "customerMobile"),
          function(o) {
            return o.flag == 17;
          }
        ).length,
      };
    },
    plus_bookings_count(state) {
      return {
        new: _.filter(_.uniqBy(state.booking_date, "mobile"), function(o) {
          return o.flag != 3 && o.flag != 4;
        }).length,
        postponed: _.filter(_.uniqBy(state.booking_date, "mobile"), function(
          o
        ) {
          return o.flag === 1;
        }).length,
        action_taken: _.filter(_.uniqBy(state.booking_date, "mobile"), function(
          o
        ) {
          return o.flag === 3;
        }).length,
        not_interested: _.filter(
          _.uniqBy(state.booking_date, "mobile"),
          function(o) {
            return o.flag === 4;
          }
        ).length,
        successful: _.filter(_.uniqBy(state.booking_date, "mobile"), function(
          o
        ) {
          return o.flag == 4;
        }).length,
        satisfied: _.filter(_.uniqBy(state.booking_date, "mobile"), function(
          o
        ) {
          return o.flag == 5;
        }).length,
      };
    },
    vehicle_count(state) {
      return {
        Available: _.filter(state.total_vehicles, function(o) {
          return o.status == 0 || null;
        }).length,
        Booked: _.filter(state.total_vehicles, function(o) {
          return o.status === 1;
        }).length,
        "Under Service": _.filter(state.total_vehicles, function(o) {
          return o.status == 2;
        }).length,
        "Ongoing Under Service": _.filter(state.total_vehicles, function(o) {
          return o.status == 3;
        }).length,
      };
    },
    notesbyid(state) {
      return (id) =>
        _.filter(state.notes, function(o) {
          return o.status == id;
        });
    },
    date() {
      var date = new Date();
      var month = date.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      var day = date.getDate();
      var year = date.getFullYear();
      if (day < 10) {
        return year + "-" + month + "-" + "0" + day;
      } else {
        return year + "-" + month + "-" + day;
      }
    },
    yesterday() {
      var date = new Date();
      var month = date.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      var day = date.getDate() - 1;
      var year = date.getFullYear();
      return year + "-" + month + "-" + day;
    },
  },
  dayBeforeYesterday() {
    var date = new Date();
    var month = date.getMonth() + 1;
    if (month < 10) {
      month = "0" + month;
    }
    var day = date.getDate() - 2;
    var year = date.getFullYear();
    return year + "-" + month + "-" + day;
  },
});
